module.exports = __webpack_public_path__ + "static/img/pic-avatar-vip3.a963041.png";